import { Text, TextVariant } from '@naf/text';
import React from 'react';
import S from '../Styles';

type Props = {
  count: number;
  selectedCounties: string[];
  name: string;
  countyNames?: Record<string, string>;
  pluralSuffix: string;
};

const CountText = ({ count, selectedCounties, name, countyNames = {}, pluralSuffix }: Props) => {
  const readableCounties =
    selectedCounties.length > 0
      ? selectedCounties
          .map((slug) => countyNames[slug] || slug.replace(/-/g, ' '))
          .join(', ')
          .replace(/, ([^,]*)$/, ' og $1')
      : 'alle fylker';

  return (
    <S.CountText>
      <Text tag="span" variant={TextVariant.BodyText}>
        Viser
      </Text>
      <Text tag="span" variant={TextVariant.BodyTextHeader}>
        {` ${count} ${name}${count > 1 ? pluralSuffix : ''} i ${readableCounties} `}
      </Text>
      <Text tag="span" variant={TextVariant.BodyText}>
        alfabetisk
      </Text>
    </S.CountText>
  );
};

export default CountText;
